var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment, useEffect, useMemo } from "react";
import { useLocationStates } from "@/shared/hooks/use-location-states";
import { FormControl, FormErrorMessage, FormLabel, Input, Select, } from "@reverb-ui/react";
import { FlexLine } from "../company-owner/flex-line";
import { RequiredIndicator } from "@/features/first-access/presentation/components/required-indicator";
import { useLocationCities } from "@/shared/hooks/use-location-cities";
import { Controller, useWatch, } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ControlledFormSelect } from "@/shared/components/controlled-form-select";
import { cepMask, filterOptionsBrazil, genericTypeToOption, optionEqualsBrazil, } from "@/shared/utils";
import MaskedInput from "@/shared/components/masked-input";
import { makeGetCep } from "@/main/factories/usecases/get-cep";
export var ModalCompanyOwnerAddressForm = function (_a) {
    var address = _a.address, index = _a.index, countries = _a.countries, _b = _a.countriesIsLoading, countriesIsLoading = _b === void 0 ? false : _b, addressTypes = _a.addressTypes, control = _a.control, register = _a.register, formErrors = _a.formErrors, isSubmitting = _a.isSubmitting, setValue = _a.setValue;
    var t = useTranslation("my-account").t;
    var getErrorMessage = function (field) { var _a, _b, _c; return (_c = (_b = (_a = formErrors.addresses) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b[field]) === null || _c === void 0 ? void 0 : _c.message; };
    var useWatchCountry = useWatch({
        control: control,
        defaultValue: undefined,
        name: "addresses." + index + ".country",
    });
    var useWatchState = useWatch({
        control: control,
        defaultValue: undefined,
        name: "addresses." + index + ".state",
    });
    var useWatchCity = useWatch({
        control: control,
        defaultValue: undefined,
        name: "addresses." + index + ".city",
    });
    var useWatchZipCode = useWatch({
        control: control,
        defaultValue: undefined,
        name: "addresses." + index + ".zipCode",
    });
    var _c = useLocationStates(useMemo(function () { return +(useWatchCountry === null || useWatchCountry === void 0 ? void 0 : useWatchCountry.value); }, [useWatchCountry === null || useWatchCountry === void 0 ? void 0 : useWatchCountry.value]), true), states = _c.states, isLoadingStates = _c.isLoading;
    var _d = useLocationCities(useMemo(function () { return +(useWatchState === null || useWatchState === void 0 ? void 0 : useWatchState.value); }, [useWatchState === null || useWatchState === void 0 ? void 0 : useWatchState.value]), true), cities = _d.cities, isLoadingCities = _d.isLoading;
    var zipCodeMask = useMemo(function () {
        if (useWatchCountry && optionEqualsBrazil(useWatchCountry)) {
            return cepMask;
        }
        return false;
    }, [useWatchCountry]);
    //Cascade State on Country
    useEffect(function () {
        if (!useWatchCountry) {
            setValue("addresses." + index + ".state", null);
            return;
        }
        if (useWatchCountry && (useWatchState === null || useWatchState === void 0 ? void 0 : useWatchState.value) && isLoadingStates === false) {
            if (useWatchState) {
                var stateIsOnStateList = states.find(function (st) { return st.value === useWatchState.value; });
                if ((stateIsOnStateList === null || stateIsOnStateList === void 0 ? void 0 : stateIsOnStateList.value) !== (useWatchState === null || useWatchState === void 0 ? void 0 : useWatchState.value))
                    setValue("addresses." + index + ".state", stateIsOnStateList !== null && stateIsOnStateList !== void 0 ? stateIsOnStateList : null);
            }
        }
    }, [useWatchCountry === null || useWatchCountry === void 0 ? void 0 : useWatchCountry.value, isLoadingStates, states, useWatchState === null || useWatchState === void 0 ? void 0 : useWatchState.value]);
    //Cascade City on State
    useEffect(function () {
        if (!useWatchState) {
            setValue("addresses." + index + ".city", null);
            return;
        }
        if (useWatchState && (useWatchCity === null || useWatchCity === void 0 ? void 0 : useWatchCity.value) && isLoadingCities === false) {
            if (useWatchCity) {
                var cityIsOnCitiesList = cities.find(function (st) { return st.value === useWatchCity.value; });
                if ((cityIsOnCitiesList === null || cityIsOnCitiesList === void 0 ? void 0 : cityIsOnCitiesList.value) !== (useWatchCity === null || useWatchCity === void 0 ? void 0 : useWatchCity.value)) {
                    if ((cityIsOnCitiesList === null || cityIsOnCitiesList === void 0 ? void 0 : cityIsOnCitiesList.value) !== (useWatchCity === null || useWatchCity === void 0 ? void 0 : useWatchCity.value))
                        setValue("addresses." + index + ".city", cityIsOnCitiesList !== null && cityIsOnCitiesList !== void 0 ? cityIsOnCitiesList : null);
                }
            }
        }
    }, [useWatchState === null || useWatchState === void 0 ? void 0 : useWatchState.value, isLoadingCities, cities, useWatchCity === null || useWatchCity === void 0 ? void 0 : useWatchCity.value]);
    useEffect(function () {
        var textCep = (useWatchZipCode === null || useWatchZipCode === void 0 ? void 0 : useWatchZipCode.trim().replaceAll("-", "")) || "";
        if (textCep.length === 8 &&
            (!useWatchCountry ||
                (useWatchCountry === null || useWatchCountry === void 0 ? void 0 : useWatchCountry.label.toLowerCase()) === "brazil" ||
                (useWatchCountry === null || useWatchCountry === void 0 ? void 0 : useWatchCountry.label.toLowerCase()) === "brasil")) {
            var getCepUseCase = makeGetCep();
            var brazil_1 = useWatchCountry || filterOptionsBrazil(countries);
            getCepUseCase
                .call({ cep: textCep, brazilCountryId: +brazil_1.value })
                .then(function (cepReturn) {
                if (cepReturn) {
                    if (!useWatchCountry)
                        setValue("addresses." + index + ".country", brazil_1);
                    setValue("addresses." + index + ".state", genericTypeToOption(cepReturn.state));
                    setValue("addresses." + index + ".city", genericTypeToOption(cepReturn.city));
                    setValue("addresses." + index + ".street", cepReturn.street);
                    setValue("addresses." + index + ".neighborhood", cepReturn.neighborhood);
                }
            });
        }
    }, [
        useWatchZipCode,
        makeGetCep,
        filterOptionsBrazil,
        genericTypeToOption,
        setValue,
    ]);
    return (React.createElement(Fragment, { key: address.addressId },
        React.createElement(FlexLine, { gap: "20px", h: undefined },
            React.createElement(FormControl, { isInvalid: getErrorMessage("addressType"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.address-type"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Controller, { defaultValue: address.addressType, name: "addresses." + index + ".addressType", control: control, rules: {
                        required: t("company-tab.modal-edit-address.address-type-required"),
                    }, render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { options: addressTypes, isDisabled: isSubmitting })));
                    } }),
                React.createElement(FormErrorMessage, null, getErrorMessage("addressType"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("zipCode"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.zip-code"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Controller, { control: control, name: "addresses." + index + ".zipCode", rules: {
                        required: t("company-tab.modal-edit-address.zip-code-required"),
                    }, render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(MaskedInput, __assign({ guide: false, mask: zipCodeMask }, field)));
                    } }),
                React.createElement(FormErrorMessage, null, getErrorMessage("zipCode"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("country"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.country"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(ControlledFormSelect, { control: control, fieldName: "addresses." + index + ".country", options: countries, isDisabled: isSubmitting, rules: {
                        required: t("company-tab.modal-edit-address.country-required"),
                    }, isLoading: countriesIsLoading }),
                React.createElement(FormErrorMessage, null, getErrorMessage("country"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("state"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.state"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(ControlledFormSelect, { control: control, fieldName: "addresses." + index + ".state", options: states, isDisabled: isSubmitting, isLoading: isLoadingStates, rules: {
                        required: t("company-tab.modal-edit-address.state-required"),
                    } }),
                React.createElement(FormErrorMessage, null, getErrorMessage("state")))),
        React.createElement(FlexLine, { gap: "20px", h: undefined },
            React.createElement(FormControl, { isInvalid: getErrorMessage("city"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.city"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(ControlledFormSelect, { control: control, fieldName: "addresses." + index + ".city", options: cities, isDisabled: isSubmitting, isLoading: isLoadingCities, rules: {
                        required: t("company-tab.modal-edit-address.city-required"),
                    } }),
                React.createElement(FormErrorMessage, null, getErrorMessage("city"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("neighborhood"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.neighborhood"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Input, __assign({}, register("addresses." + index + ".neighborhood", {
                    value: address.neighborhood,
                    required: t("company-tab.modal-edit-address.neighborhood-required"),
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("neighborhood")))),
        React.createElement(FlexLine, { gap: "20px", h: undefined },
            React.createElement(FormControl, { isInvalid: getErrorMessage("street"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.street"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Input, __assign({}, register("addresses." + index + ".street", {
                    value: address.street,
                    required: t("company-tab.modal-edit-address.street-required"),
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("street"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("number"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null,
                    t("company-tab.modal-edit-address.number"),
                    " ",
                    React.createElement(RequiredIndicator, null)),
                React.createElement(Input, __assign({}, register("addresses." + index + ".number", {
                    value: address.number,
                    required: t("company-tab.modal-edit-address.number-required"),
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("number"))),
            React.createElement(FormControl, { isInvalid: getErrorMessage("complement"), isDisabled: isSubmitting },
                React.createElement(FormLabel, null, t("company-tab.modal-edit-address.complement")),
                React.createElement(Input, __assign({}, register("addresses." + index + ".complement", {
                    value: address.complement,
                }))),
                React.createElement(FormErrorMessage, null, getErrorMessage("complement"))))));
};
